import API from './api';

const conciliacaoBaseUrl = `${process.env.REACT_APP_API_HUB}/cessao/v1/conciliacao`;

export const getParceirosConciliacao = () => API.get(`${conciliacaoBaseUrl}/listar-parceiros`);

export const getConciliacaoFlowTitulos = async params => {
  const response = await API.get(`${conciliacaoBaseUrl}/listar-grid`, { params });
  const data = response?.data?.data || [];
  const meta = response?.data?.meta || {};
  return {
    data: Array.isArray(data) ? data : [],
    rowCount: Number(meta.total || 0),
    appointment: meta.appointment || null
  };
};

// Etapa 1: dados One7 + parceiro, sem consultar a Grafeno. Retorna rápido e devolve o appointment.
export const getConciliacaoFlowTitulosBase = params =>
  getConciliacaoFlowTitulos({ ...params, step: 'base' });

// Etapa 2: reaproveita o resultado da etapa 1 (appointment) e completa com os dados da Grafeno.
export const getConciliacaoFlowTitulosBancarizador = (params, appointment) =>
  getConciliacaoFlowTitulos({
    ...params,
    step: 'bancarizador',
    ...(appointment ? { appointment } : {})
  });

// Captura um único título na Grafeno (parceiro -> One7).
export const capturarTitulo = uuidTitulo =>
  API.post(`${conciliacaoBaseUrl}/capturar-titulo`, { uuid_titulo: uuidTitulo });

// Captura vários títulos na Grafeno de uma vez (mesma rota, enviando uuids_titulos).
// Retorna o resultado por título em data.resultados.
export const capturarTitulosEmLote = uuidsTitulos =>
  API.post(`${conciliacaoBaseUrl}/capturar-titulo`, { uuids_titulos: uuidsTitulos });

// Devolve um único título na Grafeno (One7 -> parceiro). O motivo é enviado mas ainda não persistido.
export const devolverTitulo = (uuidTitulo, motivo) =>
  API.post(`${conciliacaoBaseUrl}/devolver-titulo`, { uuid_titulo: uuidTitulo, motivo });
